module.exports = __webpack_public_path__ + "static/media/01-home.630fd944.png";